var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm5.09-13.203c-.09 0-.18-.032-.27-.095-.49-.19-.802-.49-.936-.9L15.18 5.203v-.237c0-.253.222-.46.668-.617l.067-.048h.067c.536-.158.804-.426.804-.806 0-.443-.09-.72-.268-.83-.18-.11-.49-.166-.938-.166H9.42c-.447 0-.76.055-.938.166-.178.11-.268.387-.268.83 0 .38.268.648.804.806h.067l.067.048c.446.158.67.364.67.617v.237L8.615 10.8c-.134.412-.446.712-.937.902-.09.063-.18.095-.27.095-1.606.57-2.41 1.44-2.41 2.61 0 .378.067.64.2.78.135.144.403.215.804.215h5.425l.802 8.348h.536l.803-8.348h5.426c.4 0 .67-.063.803-.19.133-.126.2-.395.2-.806 0-1.17-.804-2.04-2.41-2.61z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPing);
export default __webpack_public_path__ + "static/media/icon-ping.0454ab6658ab242ce0a19abe7cc669d4.svg";
export { ForwardRef as ReactComponent };